import script from "./CZoneSelectionInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CZoneSelectionInfo.vue?vue&type=script&setup=true&lang=ts"

import "./CZoneSelectionInfo.vue?vue&type=style&index=0&id=4f1cc35a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f1cc35a"]])

export default __exports__